import { useIntl } from "react-intl";

import { defaultHeroProps } from "./all-teams";
import { PaidHeroTabPanelTemplate } from "./hero-tab-panel-template";

const OperationsTabContent = () => {
    const intl = useIntl();

    const operationsHeroProps = {
        header: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeatures.hero.operations.header",
            defaultMessage: "Operations processes made easy with Jira"
        }),
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/w4g3m6wrfl232cm6kx12p83t1sg1odlm.webp",
            alt: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeatures.operations.heroImageAlt",
                defaultMessage: "Screen capture of a Jira backlog"
            })
        }
    };

    return (
        <PaidHeroTabPanelTemplate
            {...operationsHeroProps}
            {...defaultHeroProps}
        />
    );
};

export default OperationsTabContent;
